import { render } from "./FullscreenContainer.vue?vue&type=template&id=17c9f4aa&scoped=true"
import script from "./FullscreenContainer.vue?vue&type=script&lang=js"
export * from "./FullscreenContainer.vue?vue&type=script&lang=js"

import "./FullscreenContainer.vue?vue&type=style&index=0&id=17c9f4aa&scoped=true&lang=scss"

import exportComponent from "J:\\20_Mitarbeiter\\Christian\\240626_Logo_Europa_Babylon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c9f4aa"]])

export default __exports__